// graphql/orderFeedbackQuestion.js

import { gql } from "@apollo/client";

export const GET_ORDER_FEEDBACK_QUESTIONS = gql`
  query getOrderFeedbackQuestions($targetType: String) {
    getOrderFeedbackQuestions(targetType: $targetType) {
      status
      message
      data {
        id
        question
        targetType
        answerType
        options
        isActive
        minRating
        maxRating
      }
    }
  }
`;

export const ADD_ORDER_FEEDBACK_QUESTION = gql`
  mutation addOrderFeedbackQuestion($data: OrderFeedbackQuestionInput!) {
    addOrderFeedbackQuestion(data: $data) {
      status
      message
    }
  }
`;

export const UPDATE_ORDER_FEEDBACK_QUESTION = gql`
  mutation updateOrderFeedbackQuestion($data: OrderFeedbackQuestionInput!) {
    updateOrderFeedbackQuestion(data: $data) {
      status
      message
    }
  }
`;

export const DELETE_ORDER_FEEDBACK_QUESTION = gql`
  mutation deleteOrderFeedbackQuestion($id: ID!) {
    deleteOrderFeedbackQuestion(id: $id) {
      status
      message
    }
  }
`;